<template>
  <div class="notice-card-wrapper" v-if="ismarqueue">
    <div class="header">
      <div class="title">
        <!-- 系统公告 -->
        <div class="message">
          <div class="inner-container">
            <span
              class="notice"
              v-html="notice"
              :style="{ left: noticeX + 'px' }"
            ></span>
          </div>
          <div @click="close" class="close-btn el-icon-close"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemNotice",
  props: {
    isH5: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      notice: "",
      time: null,
      ShowNotice: true,
      noticeX: 0
    };
  },
  computed: {
    ...mapState({
      NoticeMessage: state => state.NoticeMessage,
      ismarqueue: state => state.ismarqueue
    })
  },
  created() {
    this.NoticeMessage.noticeInfo.forEach(item => {
      if (item.noticeType == 0) {
        this.notice = item.noticeContent;
      }
    });
  },
  mounted() {
    const _this = this;
    const noticeElement = document.getElementsByClassName("notice")[0];
    const viewWidth = document.getElementsByClassName("inner-container")[0]
      .offsetWidth;
    const platform = process.env.VUE_APP_DEVICE;
    this.noticeX = viewWidth + 50;
    setInterval(function() {
      _this.noticeX = platform === "h5" ? _this.noticeX - 1 : _this.noticeX - 2;

      if (_this.noticeX < 0 - (noticeElement.clientWidth + 20)) {
        _this.noticeX = viewWidth + 50;
      }
    }, 50);
  },
  methods: {
    close() {
      this.$store.commit("setState", {
        ismarqueue: false
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.time);
    this.time = null;
  }
};
</script>

<style lang="less" scoped>
.message {
  display: flex;
  align-items: center;
}

.notice {
  position: absolute;
  left: 0;
}

.notice-card-wrapper {
  position: absolute;
  background: #ffffb9;
  left: 0px;
  top: 68px;
  font-size: 12px;
  width: 100%;
  padding: 0 10px;
  z-index: 1000;
}

.mobile {
  .notice-card-wrapper {
    top: 60px;

    .close-btn {
      top: 0px;
      font-size: 16px;
      margin-left: 4px;
    }
  }
}

.inner-container {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  height: 30px;
  line-height: 30px;
  width: 100%;

  .close-btn {
    position: absolute;
    width: 30px;
    text-align: center;
    top: 10px;
    cursor: pointer;
    z-index: 4;
    right: 0px;
  }
}
</style>
